export default __webpack_public_path__ + "static/media/cadillac.1fff97aa.svg";